import { useEffect, useState } from 'react';
import logo from '../logo.svg';

import { Avatar, Button, Dropdown, Menu } from 'antd';
import type { FC } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { Modal } from 'antd';

import { Form, Input, message } from 'antd';
import { changePassword, getCurrentUser,  logout } from '../services/User';

import {
    UserOutlined
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout } from 'antd';
import Device from './Device';
import Log from './Log';
import System from './System';
import Screen from './Screen';
import User from './Users';
import Groups from './Group';
import Agents from './Agent';
import Agent from './Agent';
import Group from './Group';
const { Header, Content, Footer, Sider } = Layout;

const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};

const Home2: FC = () => {
    const nav = useNavigate();
    //const [settings, setSetting] = useState<ProSettings> | undefined>({ fixSiderbar: true });
    //const [settings, setSetting] = useState<Partial<ProSettings> | undefined>({ fixSiderbar: true });
    //   const [menu, setMenu] = useState(Resources);
    const [form] = Form.useForm();
    const [menus,setMenus] = useState<any>([])

    const [isModalVisible, setIsModalVisible] = useState(false);

    const currentUser = getCurrentUser();

    if (currentUser.token === "")
        return <Navigate to="/"></Navigate>

    if (menus.length == 0)
        setMenus(currentUser.menus)
    function changePwd() {
        setIsModalVisible(true);
    }



    async function _logout() {
        await logout();
        let account = localStorage.getItem("accountInfo");
        if (account != null) {
            let oA = JSON.parse(account);
            oA.token = "";
            localStorage.setItem("accountInfo", JSON.stringify(oA));
        }
        nav("/login", { replace: true });
    }

    const handleOk = () => {
        let v = form.getFieldsValue();
        if (v.password != v.password2) {
            return message.warning("两次口令不一致!");
        }
        changePassword(v.password).then((v) => {
            console.log(v)
            setIsModalVisible(false);
            message.info("口令更改成功!");
        })
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    
    const userItems: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <Button type="link" onClick={changePwd}>更改口令</Button>
            ),
        },
        {
            key: '2',
            label: (
                <Button type="link" onClick={_logout}>退出系统</Button>
            ),
        }
    ];

    const selectMenu = (opts: any) => {
        const { item, key } = opts
        console.log(key)
        nav(`/${key}`, { replace: true });
    }

    return (
        <>
            <Modal title="修改密码" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} cancelText="取消" okText="确定">
                <Form
                    {...layout}
                    name="basic"
                    form={form}

                >
                    <Form.Item
                        label="新口令"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        label="确认口令"
                        name="password2"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            },
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                </Form>
            </Modal>
            <Layout hasSider>
                <Sider
                    style={{
                        overflow: 'auto',
                        height: '100vh',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        bottom: 0,
                    }}
                >
                    <div className="demo-logo-vertical" >
                        <img src={logo}></img>
                        <span> 中控管理服务器</span>
                    </div>
                    <Menu style={{}} onSelect={selectMenu} theme="dark" mode="inline" defaultSelectedKeys={['device']} items={menus} />
                </Sider>
                <Layout className="site-layout" style={{ marginLeft: 200 }}>
                    <Header style={{ padding: 0, display: "flex", flex: 1, justifyContent: "flex-end", paddingRight: 15 }} >
                        <Dropdown menu={{ items: userItems }}>

                            <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                <Avatar style={{
                                    backgroundColor: "#f56a00",
                                    verticalAlign: 'middle',
                                    marginRight: 5
                                }}
                                    size="small"
                                    gap={4} icon={<UserOutlined />} />{currentUser.name}
                            </a>
                        </Dropdown>

                    </Header>
                    <Content style={{ margin: '4px 4px 0 15px', overflow: 'initial' ,height:"90vh" }}>
                        <Routes>
                            <Route path="/" element={<Device />} />
                            <Route path="/home" element={<Device />} />
                            <Route path="/device" element={<Device />} />
                            <Route path="/screen" element={<Screen />} />
                            <Route path="/log" element={<Log />} />
                            <Route path="/system" element={<System />} />
                            <Route path="/user" element={<User />} />
                            <Route path="/devicegroups" element={<Group />} />
                            <Route path="/agent" element={<Agent />} />
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </>
    )

};

export default Home2;